'use client'

import { ProductCard } from '@/components/content-types/product/product-card'
import { Grid } from '@/components/ui/grid'
import { useAppSelector } from '@/lib/store'
import { ProductItem } from '@/lib/types/operations/product'

interface RelatedProductsProps {
  products: ProductItem[]
  currentProductId: string
  categoryId: string
  categoryName?: string
}

export function RelatedProducts({ products, currentProductId, categoryId, categoryName }: RelatedProductsProps) {
  // Get the current filter state from our Redux store
  const filterParams = useAppSelector((state) => state.products.filterParams)

  // Filter out the current product and limit to same category
  const relatedProducts = products
    .filter((product) => product.id !== currentProductId && product.categoryId === categoryId)
    .slice(0, 4) // Limit to 4 related products

  if (relatedProducts.length === 0) {
    return null
  }

  return (
    <div className='py-16 mt-16'>
      <div className='container mx-auto'>
        <div className='flex justify-between items-center mb-8'>
          <h2 className='text-2xl font-bold'>Related Products</h2>
        </div>

        <Grid
          items={relatedProducts}
          renderItem={(product) => (
            <ProductCard key={product.id} product={product} isRelated={true} categoryName={categoryName} />
          )}
          columns={{ base: 1, sm: 2, lg: 1 }}
          gap='md'
        />
      </div>
    </div>
  )
}
